import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ROLE_HOME } from "../lib/format";
import { PageLoader } from "../components/ProtectedRoute";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/masuk", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.role ? ROLE_HOME[data.role] : "/pilih-peran", { replace: true, state: { user: data } });
      } catch (e) {
        setError(errMsg(e, "Gagal memproses login"));
      }
    })();
  }, [location.hash, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f7f9fc]">
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-8 text-center max-w-sm">
          <p className="font-bold text-slate-900">Login gagal</p>
          <p className="text-sm text-slate-500 mt-2" data-testid="auth-callback-error">{error}</p>
          <button onClick={() => navigate("/masuk", { replace: true })} className="mt-5 text-sm font-bold text-blue-600">Coba lagi</button>
        </div>
      </div>
    );
  }
  return <PageLoader label="Menyelesaikan login..." />;
}
